import React from 'react';
import { TimePicker } from 'antd';

const Wrapper = (Component) => (props) => (
  <div style={{ position: 'relative' }}>
    <Component {...props} getPopupContainer={(trigger) => trigger.parentNode} />
  </div>
);
const TTimePicker = Wrapper(TimePicker);
//TODO
// @ts-ignore
TTimePicker.RangePicker = Wrapper(TimePicker.RangePicker);
// @ts-ignore
TTimePicker.MonthPicker = Wrapper(TimePicker.MonthPicker);

export default TTimePicker;
